import React from 'react';

const Step1Alignment = ({ formData, updateFormData, onNext }) => {
  const handleRadioChange = (field, value) => {
    updateFormData(field, value);
    
    // Reset dependent fields when changing main questions
    if (field === 'nationalPriority') {
      updateFormData('nationalIncentiveClaimed', null);
      updateFormData('nationalActionSteps', '');
    }
    if (field === 'statePriority') {
      updateFormData('stateIncentiveClaimed', null);
      updateFormData('stateActionSteps', '');
    }
  };

  const canProceed = () => {
    return formData.nationalPriority !== null && 
           formData.statePriority !== null &&
           ((formData.nationalPriority === false) || 
            (formData.nationalPriority === true && 
             (formData.nationalIncentiveClaimed !== null && 
              (formData.nationalIncentiveClaimed === true || 
               (formData.nationalIncentiveClaimed === false && formData.nationalActionSteps.trim() !== ''))))) &&
           ((formData.statePriority === false) || 
            (formData.statePriority === true && 
             (formData.stateIncentiveClaimed !== null && 
              (formData.stateIncentiveClaimed === true || 
               (formData.stateIncentiveClaimed === false && formData.stateActionSteps.trim() !== '')))));
  };

  return (
    <div className="step-content">
      <h2 className="step-title">Step 1: Alignment</h2>
      
      {/* 1.1 National Priority / Paranoia Check */}
      <div className="question-container">
        <h3 style={{ marginBottom: '20px', color: '#333', fontSize: '1.3rem' }}>
          1.1 National Priority / Paranoia Check
        </h3>
        
        <div className="question-text">
          Is your business solving a National Priority or National Paranoia?
        </div>
        
        <div className="radio-group">
          <div 
            className={`radio-option ${formData.nationalPriority === true ? 'selected' : ''}`}
            onClick={() => handleRadioChange('nationalPriority', true)}
          >
            <input
              type="radio"
              name="nationalPriority"
              checked={formData.nationalPriority === true}
              onChange={() => {}}
            />
            <label>Yes</label>
          </div>
          <div 
            className={`radio-option ${formData.nationalPriority === false ? 'selected' : ''}`}
            onClick={() => handleRadioChange('nationalPriority', false)}
          >
            <input
              type="radio"
              name="nationalPriority"
              checked={formData.nationalPriority === false}
              onChange={() => {}}
            />
            <label>No</label>
          </div>
        </div>

        {/* Conditional question for National Priority */}
        {formData.nationalPriority === true && (
          <div className="question-container" style={{ marginTop: '30px' }}>
            <div className="question-text">
              Have you claimed the respective national incentive?
            </div>
            
            <div className="radio-group">
              <div 
                className={`radio-option ${formData.nationalIncentiveClaimed === true ? 'selected' : ''}`}
                onClick={() => updateFormData('nationalIncentiveClaimed', true)}
              >
                <input
                  type="radio"
                  name="nationalIncentiveClaimed"
                  checked={formData.nationalIncentiveClaimed === true}
                  onChange={() => {}}
                />
                <label>Yes</label>
              </div>
              <div 
                className={`radio-option ${formData.nationalIncentiveClaimed === false ? 'selected' : ''}`}
                onClick={() => updateFormData('nationalIncentiveClaimed', false)}
              >
                <input
                  type="radio"
                  name="nationalIncentiveClaimed"
                  checked={formData.nationalIncentiveClaimed === false}
                  onChange={() => {}}
                />
                <label>No</label>
              </div>
            </div>

            {/* Show message or action input based on answer */}
            {formData.nationalIncentiveClaimed === true && (
              <div style={{ 
                background: '#e8f5e8', 
                padding: '15px', 
                borderRadius: '8px', 
                marginTop: '20px',
                borderLeft: '3px solid #4CAF50'
              }}>
                <strong style={{ color: '#2e7d32' }}>Great! Proceed to State Priority/Paranoia Check.</strong>
              </div>
            )}

            {formData.nationalIncentiveClaimed === false && (
              <div className="action-input-container">
                <div className="action-input-label">
                  Please write down steps you will take to claim the incentive.
                </div>
                <textarea
                  className="action-textarea"
                  value={formData.nationalActionSteps}
                  onChange={(e) => updateFormData('nationalActionSteps', e.target.value)}
                  placeholder="Enter your action steps here..."
                />
              </div>
            )}
          </div>
        )}
      </div>

      {/* 1.2 State Priority / Paranoia Check */}
      <div className="question-container">
        <h3 style={{ marginBottom: '20px', color: '#333', fontSize: '1.3rem' }}>
          1.2 State Priority / Paranoia Check
        </h3>
        
        <div className="question-text">
          Is your business solving a State Priority or State Paranoia?
        </div>
        
        <div className="radio-group">
          <div 
            className={`radio-option ${formData.statePriority === true ? 'selected' : ''}`}
            onClick={() => handleRadioChange('statePriority', true)}
          >
            <input
              type="radio"
              name="statePriority"
              checked={formData.statePriority === true}
              onChange={() => {}}
            />
            <label>Yes</label>
          </div>
          <div 
            className={`radio-option ${formData.statePriority === false ? 'selected' : ''}`}
            onClick={() => handleRadioChange('statePriority', false)}
          >
            <input
              type="radio"
              name="statePriority"
              checked={formData.statePriority === false}
              onChange={() => {}}
            />
            <label>No</label>
          </div>
        </div>

        {/* Conditional question for State Priority */}
        {formData.statePriority === true && (
          <div className="question-container" style={{ marginTop: '30px' }}>
            <div className="question-text">
              Have you claimed the respective state incentive?
            </div>
            
            <div className="radio-group">
              <div 
                className={`radio-option ${formData.stateIncentiveClaimed === true ? 'selected' : ''}`}
                onClick={() => updateFormData('stateIncentiveClaimed', true)}
              >
                <input
                  type="radio"
                  name="stateIncentiveClaimed"
                  checked={formData.stateIncentiveClaimed === true}
                  onChange={() => {}}
                />
                <label>Yes</label>
              </div>
              <div 
                className={`radio-option ${formData.stateIncentiveClaimed === false ? 'selected' : ''}`}
                onClick={() => updateFormData('stateIncentiveClaimed', false)}
              >
                <input
                  type="radio"
                  name="stateIncentiveClaimed"
                  checked={formData.stateIncentiveClaimed === false}
                  onChange={() => {}}
                />
                <label>No</label>
              </div>
            </div>

            {/* Show message or action input based on answer */}
            {formData.stateIncentiveClaimed === true && (
              <div style={{ 
                background: '#e8f5e8', 
                padding: '15px', 
                borderRadius: '8px', 
                marginTop: '20px',
                borderLeft: '3px solid #4CAF50'
              }}>
                <strong style={{ color: '#2e7d32' }}>Excellent! Proceed to Constitution Optimization.</strong>
              </div>
            )}

            {formData.stateIncentiveClaimed === false && (
              <div className="action-input-container">
                <div className="action-input-label">
                  Please write down steps you will take to claim the incentive.
                </div>
                <textarea
                  className="action-textarea"
                  value={formData.stateActionSteps}
                  onChange={(e) => updateFormData('stateActionSteps', e.target.value)}
                  placeholder="Enter your action steps here..."
                />
              </div>
            )}
          </div>
        )}
      </div>

      {/* Navigation */}
      <div className="navigation-buttons">
        <div></div> {/* Empty div for spacing */}
        <button
          className="btn btn-primary"
          onClick={onNext}
          disabled={!canProceed()}
        >
          Continue to Constitution Optimization
        </button>
      </div>
    </div>
  );
};

export default Step1Alignment;
